export default __webpack_public_path__ + "static/media/p1-1-m.3d39693b.png";